<template>
    <a :href="url" v-if="url">
        <img src="../../../src/assets/logo/logo-white.png" v-if="!invert" alt="Logo" class="max-w-full" />
        <img src="../../../src/assets/logo/logo-blue.png" v-else alt="Logo" class="max-w-full" />
    </a>
    <span v-else>
        <img src="../../../src/assets/logo/logo-white.png" v-if="!invert" alt="Logo" class="max-w-full" />
        <img src="../../../src/assets/logo/logo-blue.png" v-else alt="Logo" class="max-w-full" />
    </span>
</template>

<script>
export default {
    props: {
        classes: String,
        url: String,
        invert: {
            default() {
                return false
            }
        }
    }
}
</script>
